<template>
	<v-row
		dense
		class="ma-2"
	>
		<v-col cols="2" align-self="center">
			<v-text-field
				dense
				outlined
				:label="$T('inputs.name')"
				hide-details></v-text-field>
		</v-col>

		<v-col cols="2" align-self="center">
			<v-autocomplete
				:items="[]"
				dense
				outlined
				label="القسم"
				hide-details />
		</v-col>

		<v-col cols="2" align-self="center">
			<v-autocomplete
				:items="[]"
				dense
				outlined
				label="المسمى الوظيفي"
				hide-details />
		</v-col>
		<v-col cols="auto" class="d-flex" align-self="center">
			طبيعة العمل:
			<v-radio-group row class="mt-0" hide-details>
				<v-radio label="بعض الوقت"></v-radio>
				<v-radio label="دائم"></v-radio>
			</v-radio-group>
		</v-col>
		<v-col cols="2" align-self="center">
			<bee-date-picker
				:input-label="$T('inputs.date')"
				:input-props="{ outlined: true, dense: true, prependInnerIcon: '$calendar' }"
				:months-over-max="5"
				menu-picker
				calendar
				no-title
				hide-details></bee-date-picker>
		</v-col>
		<v-spacer />
		<v-col cols="auto" align-self="center">
			<v-btn
				type="submit"
				class="me-1"
				outlined
				small
				color="primary"	
			>
				<v-icon small left>mdi-magnify</v-icon>
				{{ $T('default-buttons.search') }}
			</v-btn>
		</v-col>
		<v-col cols="12">
			<h2 class="text-h6 mb-4 text-start">المهارات العامة</h2>	
			<bee-handy-table
				:headers="headers"
				:items="items"
				dense
				zebra
				height="auto"
				:items-per-page="-1"
				fixed-header
				hide-default-footer
			>

			<template v-slot:item.value="{ item }">
				<v-radio-group
					v-model="item.value"
					row
					hide-details
					class="mt-0"
					:disabled="Boolean($route.query.preview)"
					small
				>
					<v-radio
						label="5%"
						:value="1"
					></v-radio>
					<v-radio
						label="25%"
						:value="2"
					></v-radio>
					<v-radio
						label="50%"
						:value="3"
					></v-radio>
					<v-radio
						label="75%"
						:value="4"
					></v-radio>
					<v-radio
						label="100%"
						:value="5"
					></v-radio>
				</v-radio-group>
			</template>

				<template v-slot:item.note="{}">
					<v-text-field
						dense
						hide-details
					/>
				</template>
			</bee-handy-table>
			<!-- <v-row v-if="0">
				<template v-for="(item, j) in items">
					<v-col
						cols="3"
						:key="j + 'name'"
						style="font-size: 14px;">
						{{ item }}
					</v-col>
					<v-col
						cols="9"
						:key="j + 'radio'">
						<v-radio-group
							class="interview mt-0"
							dense
							row
							hide-details>
							<v-radio
								v-for="i in 5"
								:key="i"
								:value="i"></v-radio>
						</v-radio-group>
					</v-col>
				</template>
			</v-row> -->
		</v-col>
		<v-divider class="my-1" />
		<v-col cols="12">
			<h2 class="text-h6 mb-4 text-start"> العلاقة مع الزملاء </h2>
			<bee-handy-table
				:headers="headers"
				:items="items2"
				dense
				zebra
				height="auto"
				:items-per-page="-1"
				fixed-header
				hide-default-footer
			>

			<template v-slot:item.value="{ item }">
				<v-radio-group
					v-model="item.value"
					row
					hide-details
					class="mt-0"
					:disabled="Boolean($route.query.preview)"
					small
				>
					<v-radio
						label="5%"
						:value="1"
					></v-radio>
					<v-radio
						label="25%"
						:value="2"
					></v-radio>
					<v-radio
						label="50%"
						:value="3"
					></v-radio>
					<v-radio
						label="75%"
						:value="4"
					></v-radio>
					<v-radio
						label="100%"
						:value="5"
					></v-radio>
				</v-radio-group>
			</template>

				<template v-slot:item.note="{}">
					<v-text-field
						dense
						hide-details
					/>
				</template>
			</bee-handy-table>
		</v-col>

		<v-col cols="12">
			<h2 class="text-h6 mb-4 text-start"> الإدارة و القسم </h2>
			<bee-handy-table
				:headers="headers"
				:items="items3"
				dense
				zebra
				height="auto"
				:items-per-page="-1"
				fixed-header
				hide-default-footer
			>

				<template v-slot:item.value="{ item }">
					<v-radio-group
						v-model="item.value"
						row
						hide-details
						class="mt-0"
						:disabled="Boolean($route.query.preview)"
						small
					>
						<v-radio
							label="5%"
							:value="1"
						></v-radio>
						<v-radio
							label="25%"
							:value="2"
						></v-radio>
						<v-radio
							label="50%"
							:value="3"
						></v-radio>
						<v-radio
							label="75%"
							:value="4"
						></v-radio>
						<v-radio
							label="100%"
							:value="5"
						></v-radio>
					</v-radio-group>
				</template>

				<template v-slot:item.note="{}">
					<v-text-field
						dense
						hide-details
					/>
				</template>
			</bee-handy-table>
		</v-col>

		<v-col cols="12">
			<h2 class="text-h6 mb-4 text-start">المدير المباشر/منسق قسم</h2>
			<bee-handy-table
				:headers="headers"
				:items="items4"
				dense
				zebra
				height="auto"
				:items-per-page="-1"
				fixed-header
				hide-default-footer
			>

				<template v-slot:item.value="{ item }">
					<v-radio-group
						v-model="item.value"
						row
						hide-details
						class="mt-0"
						:disabled="Boolean($route.query.preview)"
						small
					>
						<v-radio
							label="5%"
							:value="1"
						></v-radio>
						<v-radio
							label="25%"
							:value="2"
						></v-radio>
						<v-radio
							label="50%"
							:value="3"
						></v-radio>
						<v-radio
							label="75%"
							:value="4"
						></v-radio>
						<v-radio
							label="100%"
							:value="5"
						></v-radio>
					</v-radio-group>
				</template>

				<template v-slot:item.note="{}">
					<v-text-field
						dense
						hide-details
					/>
				</template>
			</bee-handy-table>
		
		</v-col>
		<v-col cols="12">
			<h2 class="text-h6 mb-4 text-start">المدير المباشر/منسق قسم</h2>
			<!-- <v-row> -->
				<v-col cols="3">التقييم العام </v-col>
				<!-- <v-col
					cols="9"
					class="d-flex justify-space-between">
					<div class="font-weight-bold">100%</div>
					<div class="font-weight-bold">75%</div>
					<div class="font-weight-bold">50%</div>
					<div class="font-weight-bold">25%</div>
					<div class="font-weight-bold">5%</div>
				</v-col> -->
			<!-- </v-row> -->
	
			<bee-handy-table
				:headers="headers"
				:items="items"
				dense
				zebra
				height="auto"
				:items-per-page="-1"
				fixed-header
				hide-default-footer
			>
				<template v-slot:item.value="{ item }">
					<v-radio-group
						v-model="item.value"
						row
						hide-details
						class="mt-0"
						:disabled="Boolean($route.query.preview)"
						small
					>
						<v-radio
							label="5%"
							:value="1"
						></v-radio>
						<v-radio
							label="25%"
							:value="2"
						></v-radio>
						<v-radio
							label="50%"
							:value="3"
						></v-radio>
						<v-radio
							label="75%"
							:value="4"
						></v-radio>
						<v-radio
							label="100%"
							:value="5"
						></v-radio>
					</v-radio-group>
				</template>

				<template v-slot:item.note="{}">
					<v-text-field
						dense
						hide-details
					/>
				</template>
			</bee-handy-table>
		</v-col>

		<v-col cols="6">
			<v-textarea
				class="mt-3"
				label="ما أكثر شي تحبه في الشركة"
				rows="3"
				outlined
				dense
				hide-details
				auto-grow></v-textarea>
		</v-col>
		<v-col cols="6">
			<v-textarea
				class="mt-3"
				label="اذكر قيم الشركة"
				rows="3"
				outlined
				dense
				hide-details
				auto-grow></v-textarea>
		</v-col>

		<v-col cols="6">
			<v-textarea
				class="mt-3"
				label="وضح رؤية مهمة"
				rows="3"
				outlined
				dense
				hide-details
				auto-grow></v-textarea>
		</v-col>

		<v-col cols="6">
			<v-textarea
				class="mt-3"
				label="ما الأشياء التي تحتاج إلى مزيد من التنمية؟ وضح وفقاً للإهمية"
				rows="3"
				outlined
				dense
				hide-details
				auto-grow></v-textarea>
		</v-col>

		<v-col cols="12">
			<v-textarea
				class="mt-3"
				label="ما الأشياء التي لا تحبها في المؤسسة؟ و كيف يمكننا التغلب عليها من وجهة النظر الخاصة بك؟"
				rows="3"
				outlined
				dense
				hide-details
				auto-grow></v-textarea>
		</v-col>
	</v-row>
</template>
<script>
export default {
	data() {
		return {
			items: [
				{
					name: 'الشركة مكان جيد للعمل',
					value: 0,
					note: ''
				},
				{
					name: 'افهم رؤية الشركة',
					value: 0,
					note: ''
				},
				{
					name: 'افهم القيم الأساسية للشركة',
					value: 0,
					note: ''
				},
				{
					name: 'الأهداف الخاصة بي مرتبطة بأهداف الشركة',
					value: 0,
					note: ''
				},
				{
					name: 'يقوم المدير المباشر بإخباري بالواجبات الواجب عملها',
					value: 0,
					note: ''
				},
				{
					name: 'من السهل الحصول على إجابات عن الأسئلةالتي تدور حول السياسات المتعلقة بالموظفين',
					value: 0,
					note: ''
				},
				{
					name: 'يتم أخذ المقترحات الخاصة بعين الاعتبار ',
					value: 0,
					note: ''
				},
				{
					name: 'تساعدني ظروف العمل المحيطة بي على الإنتاجية',
					value: 0,
					note: ''
				},
				{
					name: 'أشعر أن الراتب ضعيف',
					value: 0,
					note: ''
				},
				{
					name: 'أشارك في اتخاذ القرارات التي تؤثر على عملي',
					value: 0,
					note: ''
				},
				{
					name: 'ليس لدي ضغوط',
					value: 0,
					note: ''
				},
				{
					name: 'تساعدني ظروف العمل المحيطة بي على الإنتاجية',
					value: 0,
					note: ''
				},
				{
					name: 'أشعر بأن الراتب بي ضعيف',
					value: 0,
					note: ''
				},
				{
					name: 'أشارك في اتخاذ القرارات التي تؤثر على عملي',
					value: 0,
					note: ''
				},
				{
					name: 'ليس لدي ضغوط في العمل',
					value: 0,
					note: ''
				},
				{
					name: 'لدي مسار واضح للتقدم الوظيفي',
					value: 0,
					note: ''
				},
				{
					name: 'وصفي الوظيفي متماش مع مهامي وواجباتي الوظيفية',
					value: 0,
					note: ''
				},
				{
					name: 'أشعر بأنني ألعب دورا مهما في تحقيق مهمة المؤسسة',
					value: 0,
					note: ''
				}
			],

			items2:[
				{
					name: 'تشجع الإدارة الخاصة بي فريق العمل',
					value: 0,
					note: ''
				},
				{
					name: 'أعضاء المؤسسة مؤهلون بما فيه الكفاية للقيام بالعمل',
					value: 0,
					note: ''
				},
				{
					name: 'أقوم بمناقشة الواجبات الوظيفية مع الزملاء',
					value: 0,
					note: ''
				},
				{
					name: 'كل شخص في المؤسسة يكن لي الاحترام',
					value: 0,
					note: ''
				}
			],
			items3: [
				{
					name: 'لدي سلطات تساعدني في إدارة العمل',
					value: 0,
					note: ''
				},
				{
					name: 	'يقوم جميع أفراد الإدارة بتنفيذ الخطة الخاصة بالعمل',
					value: 0,
					note: ''
				},
				{
					name: 'هناك توافق جيد بين الإدارة الخاصي بي وبين الآخرين دون الحاجة للتنسيق',
					value: 0,
					note: ''
				},
				{
					name: 	'إداراتي على علم تام بالإدارات ذات الصلة داخل المؤسسة',
					value: 0,
					note: ''
				}
			],
			items4: [
				{
					name: '	أستطيع أن أفهم جيدا توقعات رئيسي',
					value: 0,
					note: ''
				},
				{
					name: 'رئيس القسم يقوم بتحفيزي اذا قمت بعمل جيد',
					value: 0,
					note: ''
				},
				{
					name: 'المشرف المباشر بمثابة قدوة ايجابية',
					value: 0,
					note: ''
				},
				{
					name: 'معنويات زملاء العمل هي موضع تقدير',
					value: 0,
					note: ''
				}
			],
			items5: [
				{
					name: 'المزايا والتعويضات مرضية',
					value: 0,
					note: ''
				},
				{
					name: 'المعدات التقنية للمكان مرضية',
					value: 0,
					note: ''
				},
				{
					name:	'أنا فخور بالعمل في المؤسسة',
					value: 0,
					note: ''
				}	
			],
			headers: [
				{
					text: 'مكان العمل',
					name: 'name',
					value: 'name'
				},
				{	
					text: '',
					name: 'value',
					value: 'value'
				},
				{
					text: '',
					name: 'note',
					value: 'note'
				}
			]
		}
	}
}
</script>
